var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header" }, [
    _c("div", { staticClass: "header-detalis" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "header-title" }, [
          _c(
            "div",
            { staticClass: "me-2" },
            [_vm.user_role == 1 ? [_vm._m(0)] : [_vm._m(1)]],
            2
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4)
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "header-menu" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "main-menu" }, [
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _c("div", {}, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.loadCodeofConduct.apply(null, arguments)
                  }
                }
              },
              [
                _vm._v(
                  "\n                        CODE OF BUSINESS ETHICS\n                    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "search-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              ref: "searchInput",
              staticClass: "form-control text-box",
              attrs: { type: "text" },
              domProps: { value: _vm.search },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.triggerSearch.apply(null, arguments)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.search ? _vm.searchUrl : "javascript:void(0)"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleSearchClick.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n                        SEARCH\n                    ")]
            )
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.logout.apply(null, arguments)
                  }
                }
              },
              [_vm._v("LOGOUT")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "/backend/list/newsannouncements" } }, [
      _c("img", {
        staticClass: "header-img",
        attrs: { src: "/static/images/vtc-icon.png", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "/" } }, [
      _c("img", {
        staticClass: "header-img",
        attrs: { src: "/static/images/vtc-icon.png", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "compliance-info" }, [
      _c("span", { staticClass: "header-title" }, [_vm._v("WELCOME TO THE")]),
      _vm._v(" "),
      _c("h1", { staticClass: "sub-title" }, [
        _vm._v("COMPLIANCE & ETHICS PORTAL")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "header-content" }, [
        _vm._v(
          "On VVG’s internal compliance and ethics portal, we hope to guide and empower our employees to uphold the highest standards of compliance and ethics. We encourage you to navigate through the resources and materials provided to enhance your understanding and commitment to our company's values. This portal serves as a central hub for information sharing and promoting a culture of accountability within our organization. Together, we can uphold the commitment to compliance, ethics, and integrity that defines us and ensures our continued success."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ms-2" }, [
      _c("img", {
        staticClass: "header-img",
        attrs: { src: "/static/images/compliance-icon.png", alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("div", { staticClass: "hamburger-logo" }, [
        _c("a", {
          staticClass: "fa fa-search search-logo",
          attrs: {
            id: "search-logo",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "bottom"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "serch-textaera" }, [
          _c("i", { staticClass: "fa fa-search search-logo" }),
          _vm._v(" "),
          _c("input", {
            staticClass: "text-boxarea",
            attrs: { type: "text", placeholder: "search" }
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-times",
            attrs: { id: "close-textaera" }
          })
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-bars hamburger-menu" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("a", { attrs: { href: "/ondemandtrainings" } }, [
        _vm._v("ON-DEMAND TRAINING")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("a", { attrs: { href: "/policies" } }, [_vm._v("POLICIES")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("a", { attrs: { href: "/projects" } }, [_vm._v("PROJECTS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href:
              "https://secure.ethicspoint.com/domain/media/en/gui/92280/index.html"
          }
        },
        [_vm._v("SPEAK UP LINE")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5fdd6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5fdd6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = null
// module chunks = 